import httpManager from "@/app/shared/utils/httpManager";

/**
 * Fetch whatsapp template associated to a channel id
 *
 * @param {Object} channelCustomerId
 *
 * @return {Promise<Object>}
 */
export async function fetchTemplates({ channelCustomerId, filters = {} } = {}) {
  const { search, category, status, state } = filters;

  const response = await httpManager.get(
    `/channels/channel-customer/${channelCustomerId}/whatsapp-templates/?search=${
      search || ""
    }&category=${category || ""}&status=${status || ""}&state=${state || ""}`
  );

  return response?.data;
}
